"use strict";
/**
 * Работа с денежными значениями.
 *
 * Деньги никогда не хранятся и не считаются в числах с плавающей точкой:
 * сумма — целое число минорных единиц (12.50 € → 1250) плюс код валюты.
 * Суммы разных валют не складываются без явно заданного курса — в MVP курса
 * нет, поэтому итоги всегда группируются по валюте.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAmountToMinor = parseAmountToMinor;
exports.formatMoney = formatMoney;
exports.sumByCurrency = sumByCurrency;
exports.toMonthlyEquivalent = toMonthlyEquivalent;
const enums_1 = require("./enums");
function parseAmountToMinor(input, currency) {
    const normalized = input.replace(/\s/g, '').replace(',', '.');
    if (!/^-?\d+(\.\d+)?$/.test(normalized))
        return null;
    const digits = enums_1.CURRENCY_MINOR_DIGITS[currency];
    const [whole = '0', fraction = ''] = normalized.split('.');
    const padded = fraction.padEnd(digits, '0').slice(0, digits);
    const sign = whole.startsWith('-') ? -1 : 1;
    const wholeDigits = whole.replace('-', '');
    const value = Number(wholeDigits) * 10 ** digits + Number(padded || '0');
    return Number.isSafeInteger(value) ? sign * value : null;
}
function formatMoney(money, options = {}) {
    const { withSymbol = true, locale = 'ru-RU' } = options;
    const digits = enums_1.CURRENCY_MINOR_DIGITS[money.currency];
    const value = money.amountMinor / 10 ** digits;
    const formatted = new Intl.NumberFormat(locale, {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    }).format(value);
    return withSymbol ? `${formatted} ${enums_1.CURRENCY_SYMBOLS[money.currency]}` : formatted;
}
/**
 * Группирует суммы по валюте. Возвращает массив, а не одно число — складывать
 * разные валюты без курса запрещено.
 */
function sumByCurrency(amounts) {
    const totals = new Map();
    for (const amount of amounts) {
        const existing = totals.get(amount.currency);
        if (existing) {
            existing.amountMinor += amount.amountMinor;
            existing.count += 1;
        }
        else {
            totals.set(amount.currency, {
                currency: amount.currency,
                amountMinor: amount.amountMinor,
                count: 1,
            });
        }
    }
    return [...totals.values()].sort((a, b) => b.amountMinor - a.amountMinor);
}
/**
 * Приводит периодический расход к месячному эквиваленту в той же валюте.
 * Разовые расходы в месячный эквивалент не входят.
 */
function toMonthlyEquivalent(money, recurrence) {
    switch (recurrence) {
        case 'MONTHLY':
            return money;
        case 'QUARTERLY':
            return { ...money, amountMinor: Math.round(money.amountMinor / 3) };
        case 'YEARLY':
            return { ...money, amountMinor: Math.round(money.amountMinor / 12) };
        case 'ONE_TIME':
        case 'OTHER':
            return null;
    }
}
//# sourceMappingURL=money.js.map